import { createBlankCriteria } from './createBlankCriteria';
import { convertToEditableRequirement } from './convertToEditableRequirement';
import { CompleteCriteria, EditableCriteria } from '../types';

/** converts ComplateCriteria to EditableCriteria */
export const convertToEditableCriteria = (criteria: CompleteCriteria): EditableCriteria =>
  createBlankCriteria({
    ...criteria,
    searchQueries: criteria.searchQueries.map(convertToEditableRequirement),
  });
